import Box from '@mui/material/Box';

import { CancelSearchButton } from '../../common/data-grids/common/CancelSearchButton';
import { SearchInput } from '../../common/data-grids/common/SearchInput';

import type { FunctionComponent } from 'react';

export const TableBarSearch: FunctionComponent<{
    readonly onSearchBarCancelButtonClick: () => void;
}> = ({ onSearchBarCancelButtonClick }) => (
    <Box
        sx={{
            alignItems: 'center',
            display: 'flex',
            gap: 3,
            paddingY: 1,
            width: '100%',
        }}
    >
        <SearchInput />
        <CancelSearchButton onClick={onSearchBarCancelButtonClick} />
    </Box>
);
